<form [formGroup]="form" class="content">
    <div class="replace-param-title"  [ngClass]="{'has-title': title}" fxLayout="row" fxLayoutAlign="flex-end center">
        <h4 *ngIf="title">{{title}}</h4>
        <button [matMenuTriggerFor]="menu" mat-stroked-button color="primary"><mat-icon svgIcon="plus"></mat-icon> Variável</button>
    </div>
    <td-code-editor #editor fxFlex="100" [formControlName]="nameFormControl" class="ps_formBuilder_editor" theme="vs-dark" flex
        [editorOptions]="{ minimap: { enabled: false }, autoIndent: 'full' }" [language]="'xml'">
    </td-code-editor>
</form>

<mat-menu #menu="matMenu" xPosition="before">
    <button *ngFor="let variable of variables" mat-menu-item (click)="addVar(variable)">
        <span>{{variable.label}}</span>
    </button>
</mat-menu>
